import type { LoadLocationDataParams } from "../map/types";
import type { PostalCodePillData } from "../../@types/mapviewxs";
import { validateZipcode } from "../../utils/validation";

export interface Input {
  apiKey?: string;
  marketplaceId?: string;
  open: boolean;
  postalCodePillData?: PostalCodePillData;
  loading?: boolean;
  userLocationZipcode?: string;
  "on-close"?: () => void;
  "on-submit"?: (data: LoadLocationDataParams) => void;
}

interface State {
  zipcodeValue: string;
  distanceValue: string;
  showErrorMessage?: boolean;
}

export default class extends Marko.Component<Input, State> {
  setDefaultFormState(input: Input) {
    const { postalCodePillData } = input;
    const updateLocationModal = postalCodePillData?.updateLocationModal;
    const selectedDistanceOption = updateLocationModal?.distanceOptions?.entries?.find(({ selected }) => selected);
    const sliderSelected = updateLocationModal?.distanceSlider?.selected;
    this.state = {
      zipcodeValue: postalCodePillData?.postalCode ?? "",
      distanceValue: sliderSelected?.toString() ?? selectedDistanceOption?.fieldId ?? "",
      showErrorMessage: false,
    };
  }
  useUserZipcode() {
    const { userLocationZipcode } = this.input;
    if (userLocationZipcode) {
      this.state.zipcodeValue = userLocationZipcode;
      this.state.showErrorMessage = false;
    }
  }
  onCreate(input: Input) {
    this.setDefaultFormState(input);
  }
  onInput(input: Input) {
    if (input.open) {
      this.setDefaultFormState(input);
    }
  }
  onPostCodeTextboxChange(e: { value: string }) {
    const { value } = e;
    this.state.zipcodeValue = value;

    if (this.state.showErrorMessage) {
      this.state.showErrorMessage = false;
    }
  }
  onDistanceOptionChange(e: { value: string }) {
    const { value } = e;
    this.state.distanceValue = value;
  }

  isZipcodeValid() {
    const { zipcodeValue } = this.state;
    const { validation } = this.input.postalCodePillData?.updateLocationModal?.postalCodeEntry || {};

    return validateZipcode(zipcodeValue, {
      validation,
    });
  }
  async onSubmit() {
    if (await this.isZipcodeValid()) {
      this.emit("close");
      this.emit("submit", {
        zipcode: this.state.zipcodeValue,
        distance: this.state.distanceValue,
      });
    } else {
      this.state.showErrorMessage = true;
    }
  }
}
